const ENROLLMENT_API = '/sitecore/api/ssc/isagenix/enrollmentapi/1';
const ENROLLMENT_SESSION_API = '/sitecore/api/ssc/rw/isagenix/enrollmentapi';

export async function findAFriend(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        type: 'POST',
        url: `${ENROLLMENT_API}/enrollmentsponsorsearch`,
        headers: { __RequestVerificationToken: token },
        data: request
    });
}

export async function setEnrollmentSponsor(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        type: 'POST',
        url: `${ENROLLMENT_SESSION_API}/setenrollmentsponsor`,
        headers: { __RequestVerificationToken: token },
        data: request
    });
}
